import React from "react";

import ClientsListView from "./ClientsListView";
import useClientsList from './hooks/useClientsList';

import "./Clients.scss";

const Clients = () => {
  const listProps = useClientsList();

  return <ClientsListView {...listProps} />;
};

export default Clients;
